import React, { useState, useEffect } from 'react';
import { Card } from 'soxo-bootstrap-core';
import { Items } from '../../../../../models';
import './package-selector.scss';
import PackageSelectorIcon from '/src/assets/icons/PackageSelector.svg';
import { SectionTitle } from '../rendering-components';

export default function PackageSelector({ selectedPackage, onSelect, autoSelectFirst = true, appointId, packageValue }) {
    const [packages, setPackages] = useState([]);
    // Fetch packages
    const getPackages = async () => {
        try {
            const result = await Items.getItemsWithRate();
            const fetched = result && result[0] ? result[0] : [];
            setPackages(fetched);
        } catch (err) {
            console.error('Failed to load packages', err);
            setPackages([]);
        }
    };

    useEffect(() => {
        getPackages();
    }, []);
    // Helper to normalize package object before sending to parent
    const transformPkg = (pkg) => {
        
        let imgLink = {};
        try {
            imgLink = pkg?.itm_otherdet3 ? JSON.parse(pkg.itm_otherdet3) : {};
        } catch (e) {
            // malformed JSON fallback
            imgLink = {};
        }

        return {
            ...pkg,
            image: imgLink.item_image || null,
            price: pkg.ir_rate || 0,
            name: pkg.itm_desc || '',
        };
    };

    // Auto-select first package once packages are loaded (only if parent hasn't selected one)
    useEffect(() => {
        if (appointId) {
            let filter = packages.filter((ele) => ele.itm_code === packageValue);
            if (filter.length) {
                onSelect(transformPkg(filter[0]));
            }
        } else {
            if (autoSelectFirst && packages?.length && !selectedPackage && typeof onSelect === 'function') {
                onSelect(transformPkg(packages[0]));
            }
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [packages, autoSelectFirst]); // intentionally not watching selectedPackage to avoid re-triggering

    // Click handler for user selection
    const handleClick = (pkg) => {
        if (selectedPackage?.itm_code === pkg.itm_code) {
            onSelect && onSelect(null); // toggle off if clicked again
            return;
        }
        onSelect && onSelect(transformPkg(pkg));
    };

    return (
        <Card className="card card-shadow package-card">
            <SectionTitle
                icon={PackageSelectorIcon}
                label=" Select Package"
                className="section-title-cls"
                imgStyle={{ width: 20, height: 20, marginRight: 8 }}
            />
            {packages.length === 0 ? (
                <p style={{ color: '#888' }}>No packages available</p>
            ) : (
                <div className="package-list">
                    {packages.map((pkg) => {
                        const isSelected = selectedPackage?.itm_code === pkg.itm_code;
                            const isDisabled = packageValue ? pkg.itm_code !== packageValue : false;
                        let imgSrc = '/fallback.png';
                        try {
                            imgSrc = pkg.itm_otherdet3 ? JSON.parse(pkg.itm_otherdet3)?.item_image || '/fallback.png' : '/fallback.png';
                        } catch (e) {
                            imgSrc = '/fallback.png';
                        }

                        return (
                            <div
                                key={pkg.itm_code}
                                // className={`package-item ${isSelected ? 'selected' : ''}`}
                                className={`package-item ${isSelected ? 'selected' : ''} ${isDisabled ? 'disabled' : ''}`}
                                onClick={() => !isDisabled && handleClick(pkg)}
                                style={{
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                    alignItems: 'center',
                                    padding: '8px 12px',
                                    border: '1px solid #ddd',
                                    borderRadius: 8,
                                    marginBottom: 8,
                                    cursor: 'pointer',
                                }}
                            >
                                <div className="package-info" style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                                    {pkg.itm_otherdet3 && (
                                        <img src={imgSrc} alt={pkg.itm_desc} style={{ width: 32, height: 32, borderRadius: 6, objectFit: 'cover' }} />
                                    )}
                                    <div>
                                        <div style={{ color: '#76839A', fontSize: 12 }}>{pkg.itm_shortdetails}</div>
                                        <div style={{ fontWeight: 500, color: '#19374F' }}>₹{pkg.ir_rate?.toLocaleString()}</div>
                                    </div>
                                </div>

                                <div
                                    style={{
                                        width: 20,
                                        height: 20,
                                        border: '1px solid #a9acb0ff',
                                        borderRadius: '60%',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        backgroundColor: isSelected ? '#0C66E4' : 'transparent',
                                    }}
                                    className="package-check-box"
                                >
                                    {isSelected && (
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            viewBox="0 0 24 24"
                                            width="16"
                                            height="16"
                                            fill="none"
                                            stroke="white"
                                            strokeWidth="3"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                        >
                                            <polyline points="20 6 9 17 4 12" />
                                        </svg>
                                    )}
                                </div>
                            </div>
                        );
                    })}
                </div>
            )}
        </Card>
    );
}
